import axios from "axios";

const BASE_URL = "https://shopquocpham.herokuapp.com/api";

// const TOKEN =
//   JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user).currentUser
//     .accessToken || "";

const TOKEN = JSON.parse

// const TOKEN =
//   JSON.parse(localStorage.getItem("persist:root")).user.currentUser
   
export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
  header: { token: `Bearer ${TOKEN}` },
});

